import { enSidebarTranslation } from './components/sidebar';
import { enPagesTranslation } from './pages';

// en-US.js
export const translationEN = {
  common: {
    filters: {
      table_salary: 'Table salary',
      unit: 'Unit',
      director: 'Director',
      area: 'Area',
      grade_level: 'Grade level',
      contract_type: 'Contract type',
      employee_code: 'Employee code',
    },
    actions: {
      search: 'Search',
      apply: 'Apply',
      edit: 'Edit',
      create: 'Create',
      save: 'Save',
      delete: 'Delete',
      remove: 'Remove',
      clear: 'Clear',
      download: 'Download',
      cancel: 'Cancel',
      confirm: 'Yes, continue!',
    },
  },
  components: {
    ...enSidebarTranslation,
  },
  pages: {
    ...enPagesTranslation,
  },
};
